import { command, type Store } from 'ccstate'
import { StoreProvider } from 'ccstate-react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { setRootSignal$ } from '../common/ccstatex/rootSignal.ts'
import { initAuthStates$ } from './infra/authClient.ts'
import { initRoutes$ } from './infra/router/navigate.ts'
import * as stateTreeRoot from './state/index.ts'
import { setupPrototype } from './prototype/setupPrototype.ts'
import CurrentPage from './CurrentPage.tsx'
import './index.css'
import { injectState } from '../common/ccstatex/injectState.ts'
import { takeStateSnapshot } from '../common/ccstatex/takeStateSnapshot.ts'
import './pages/index.ts'
const usePrototype = process.env.VITE_USE_PROTOTYPE === 'true' || process.env.VITE_SUPABASE_URL === undefined
const bootstrap$ = command(async ({ get, set }, store: Store) => {
  const rootController = new AbortController()
  if (usePrototype) {
    set(setupPrototype)
  }
  set(setRootSignal$, rootController.signal)
  if (globalThis._injected) {
    const FAKE_JSON = globalThis._injected
    injectState(stateTreeRoot, FAKE_JSON)
  }
  globalThis.takeStateSnapshot = async () => {
    console.log(await takeStateSnapshot(get, stateTreeRoot))
  }
  if (!usePrototype) {
    set(initAuthStates$)
  }
  createRoot(document.getElementById('bundler-root')!).render(<StrictMode data-id="eg9iao">
    <StoreProvider value={store} data-id="pit8uf">
      <CurrentPage data-id="8qrdpc"/>
    </StoreProvider>
  </StrictMode>)
  await set(initRoutes$, rootController.signal)
})
export const bootstrap = async (store: Store) => {
  await store.set(bootstrap$, store)
}
